
// const cartUpdateManager = () => {
//   if(SET_UP_FEE_PRODUCT) {
//   // total number of products that are under the limit
//   let set_count = 0;
//   fetch("/cart.js") // requesting the server for cart data
//     .then((response) => response.json())
//     .then(({ items }) => {
//       // filtering out fee product to make 
//       const productWithoutSampleDecoration = items.filter((item) => item?.properties["Decorations Type"]?.toLowerCase() === "sample");
//       const setUpProductInCart = items.filter((item) => item?.id === SET_UP_FEE_PRODUCT);
//       // Calculate valid setup fee count
//       set_count = items
//         .filter(item => item.id !== SET_UP_FEE_PRODUCT) // Exclude fee product itself
//         .reduce((count, item) => {
//           // Get decoration type safely
//           const decorationType = item.properties?.['Decorations Type']?.toLowerCase() || 'none';
//           // Check quantity against limit
//           if (item.quantity <= SET_UP_LIMIT && !(decorationType === 'sample' || decorationType === 'none')) {
//             return count + 1;
//           }
//           return count;
//         }, 0);

//       console.log(set_count)
      
//       // data when fee product is not in cart
//       const formData = {
//         "items": [
//           {
//             'id': SET_UP_FEE_PRODUCT,
//             'quantity': set_count,
//             'properties': {
//             'Limit': `Under ${SET_UP_LIMIT+1} Quantity Setup Fee`
//           }
//           },
//         ]
//       }
//       // data when fee product is available in cart
//       const formDataChange = {
//         'id': `${SET_UP_FEE_PRODUCT}`,
//         'quantity': set_count
//       };
//       // Some testing logs
//       // console.log(`count: ${set_count}\n quantity: ${setUpProductInCart[0]?.quantity}...`);
//       console.log(productWithoutSampleDecoration)


//       // most important part of the functionality
//       if (!setUpProductInCart.length) {
//         // If the setup product is not in the cart, add it
//         if (set_count > 0) {
//           addToCartHandler(formData, "add");
//         }
//       } else if (productWithoutSampleDecoration.length !== set_count) {
//         // If the setup product exists but the quantity is incorrect, change it
//         addToCartHandler(formDataChange, "change");
//       } else {
//         // No changes are needed
//         console.log("No changes needed");
//       }
//       // console.log(`${set_count} products have quantity less than ${SET_UP_LIMIT}...`);
//     })
//     .catch((err) => console.log(err));
//   } else {
//     console.log("Id not found!!!")
//   }
// };

// // This function handles the add to cart functionality 
// const addToCartHandler = (formData, action) => {
//   fetch(`/cart/${action}.js`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then((response) => {
//       return response.json();
//     })
//     .then((data) => {
//       // console.log(`Action= ${action} called`);
//       // this condition only works when user is on cart page
//       if (window.location.pathname == '/cart') document.querySelector('#main-cart-items .cart-item__quantity input.quantity__input.hidden')?.dispatchEvent(new Event("change", { bubbles: true })); 
//       // this code refreshes the cart the is just a trick but it does the job 
//       if (window.location.pathname != '/cart') document.querySelector('form.cart__contents input.quantity__input.hidden')?.dispatchEvent(new Event("change", { bubbles: true }));
//     })
//     .catch((er) => console.log(er));
// };


// Add flag to prevent infinite loops
let isUpdatingCart = false;

// const cartUpdateManager = debounce(() => {
//   if (!SET_UP_FEE_PRODUCT || isUpdatingCart) return;
  
//   isUpdatingCart = true;
//   fetch("/cart.js")
//     .then(response => response.json())
//     .then(({ items }) => {
//       // Group items by product + decoration type
//       const groupedItems = items.reduce((groups, item) => {
//         if (item.id === SET_UP_FEE_PRODUCT) return groups;
        
//         const decorationType = (item.properties?.['Decorations Type']?.toLowerCase() || 'none');
//         const key = `${item.id}_${decorationType}`;
        
//         groups[key] = {
//           quantity: (groups[key]?.quantity || 0) + item.quantity,
//           decorationType
//         };
//         return groups;
//       }, {});

//       // Calculate valid setup fee count
//       const set_count = Object.values(groupedItems).reduce((count, { quantity, decorationType }) => {
//         return (decorationType !== 'sample' && 
//                 decorationType !== 'none' && 
//                 quantity <= SET_UP_LIMIT) ? count + 1 : count;
//       }, 0);

//       console.log(set_count)

//       // Find existing setup product
//       const setupProduct = items.find(item => item.id === SET_UP_FEE_PRODUCT);
      
//       // Determine if update needed
//       if (!setupProduct && set_count > 0) {
//         addToCartHandler({ 
//           items: [{
//             id: SET_UP_FEE_PRODUCT,
//             quantity: set_count,
//             properties: { Limit: `Under ${SET_UP_LIMIT+1} Quantity Setup Fee` }
//           }]
//         }, "add");
//       } else if (setupProduct && setupProduct.quantity !== set_count) {
//         addToCartHandler({ 
//           id: setupProduct.key, // Use line item key
//           quantity: set_count 
//         }, "change");
//       } else {
//         console.log("No setup fee changes needed");
//         isUpdatingCart = false;
//       }
//     })
//     .catch(console.error);
// }, 300);

const cartUpdateManager = debounce(() => {
  if (!SET_UP_FEE_PRODUCT || isUpdatingCart) return;
  
  isUpdatingCart = true;
  fetch("/cart.js")
    .then(response => response.json())
    .then(({ items }) => {
      let totalValidQuantity = 0;
      const EXCLUDED_TYPES = ['sample', 'none'];

      items.forEach(item => {
        if (item.id === SET_UP_FEE_PRODUCT) return;
        
        const decorationType = (item.properties?.['Decorations Type']?.toLowerCase() || 'none');
        
        // Count all items except excluded types
        if (!EXCLUDED_TYPES.includes(decorationType)) {
          totalValidQuantity += item.quantity;
        }
      });

      // Determine if we should add/keep the fee
      const shouldAddFee = totalValidQuantity > 0 && 
                         totalValidQuantity <= SET_UP_LIMIT;

      const set_count = shouldAddFee ? 1 : 0;

      console.log('Setup Fee Calculation:', {
        totalValidQuantity,
        SET_UP_LIMIT,
        shouldAddFee,
        set_count
      });

      // Find existing setup product
      const setupProduct = items.find(item => item.id === SET_UP_FEE_PRODUCT);
      
      // Update logic
      console.log(setupProduct)
      if (!setupProduct && set_count > 0) {
        addToCartHandler({ 
          items: [{
            id: SET_UP_FEE_PRODUCT,
            quantity: set_count,
            properties: { Limit: `Under ${SET_UP_LIMIT+1} Quantity Setup Fee` }
          }]
        }, "add");
      } else if (setupProduct && setupProduct.quantity !== set_count) {
        addToCartHandler({ 
          id: setupProduct.key,
          quantity: set_count 
        }, "change");
      } else {
        console.log("No setup fee changes needed");
        isUpdatingCart = false;
      }
    })
    .catch(console.error);
}, 300);

// Modified addToCartHandler
const addToCartHandler = debounce((formData, action) => {
  fetch(`/cart/${action}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(() => {
    // Smart refresh only when needed
       if (window.location.pathname == '/cart') document.querySelector('#main-cart-items .cart-item__quantity input.quantity__input.hidden')?.dispatchEvent(new Event("change", { bubbles: true })); 
//       // this code refreshes the cart the is just a trick but it does the job 
      if (window.location.pathname != '/cart') document.querySelector('form.cart__contents input.quantity__input.hidden')?.dispatchEvent(new Event("change", { bubbles: true }));
    isUpdatingCart = false;
  })
  .catch(err => {
    console.error(err);
    isUpdatingCart = false;
  });
}, 500);

// Utility function
function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
}